export const DEFAULT_DATE_FORMAT = 'D/M/YYYY';
export const DEFAULT_TIME_FORMAT = 'h:mm A';
export const LOCAL_TIME_FORMAT = 'LT';
export const FR_CA_LOCALE = 'fr-CA';
export const EN_CA_LOCALE = 'en-CA';
export const EN_US_LOCALE = 'en-US';
export const EN_LOCALE = 'en';
export const DATE_TIME_TWO_DIGIT_FORMAT = '2-digit';
export const DATE_TIME_NUMERIC_FORMAT = 'numeric';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DATE_TIME_FORMAT = 'MMM DD, YYYY | hh:mm A';
export const DATE_FORMAT_MM_DD_YYYY_HH_MM = 'MM/DD/YYYY hh:mm A';
export const DATE_FORMAT_MM_DD_YY_HH_MM = 'MM/DD/YY hh:mm A';
export const DATE_FORMAT_M_D_YY_HH_MM_A = 'M/D/YY hh:mm A';
export const DATE_FORMAT_M_D_YY = 'M/D/YY';
export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
export const DATE_FORMAT_YYYY_MM_DD_HH_MM_SS = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT_YYYY_MM_DD_HH_MM = 'YYYY-MM-DD HH:mm';
export const DATE_FORMAT_YYYY = 'YYYY';
export const DATE_FORMAT_MMMM_DD_HH_MM_A = 'MMMM DD, h:mm A';
export const DATE_FORMAT_MMMM_DD = 'MMMM DD';
export const DATE_FORMAT_CA_YYYY_MM_DD = 'YYYY/MM/DD';
export const DATE_FORMAT_EN_US_M_D_YYYY = 'M/D/YYYY';
export const DATE_FORMAT_DE_DD_MM_YY_HH_MM = 'DD.MM.YY HH:mm';
export const DATE_FORMAT_FR_CA_YY_MM_DD_HH_MM = 'YY-MM-DD HH:mm';
export const DATE_FORMAT_IT_DD_MM_YY_HH_MM = 'DD/MM/YY HH:mm';
export const DATE_FORMAT_ES_D_M_YY_H_MM = 'D/M/YY H:mm';
export const DATE_FORMAT_DD_MM_YYYY_HH_MM = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_M_D_YY_H_MM_A = 'M/D/YY h:mm A';
export const DATE_FORMAT_DE_DD_MM_YY = 'DD.MM.YY';
export const DATE_FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
export const DATE_FORMAT_FR_CA_YY_MM_DD = 'YY-MM-DD';
export const DATE_FORMAT_IT_DD_MM_YY = 'DD/MM/YY';
export const DATE_FORMAT_ES_D_M_YY = 'D/M/YY';
export const DATE_FORMAT_MMM_DD_YYYY = 'MMM DD, YYYY';
export const DATE_FORMAT_YYYY_MM_DD_HH_MM_SS_A = 'YYYY-MM-DD hh:mm:ss A'; // Format: 2024-04-07 01:40:10 PM
export const DATE_FORMAT_MM_DD_YYYY_HH_MM_SS_A = 'MM/DD/YYYY hh:mm:ss A'; // Format: 04/07/2024 01:40:10 PM
export const DATE_FORMAT_MM_DD_YYYY = 'MM/DD/YYYY';
// note that 'LT' is only meaningful to moment js library
export const DD_MM_YYYY_MILITARY_TIME_FORMAT = 'DD/MM/YYYY LT';
export const MM_DD_YYYY_NON_MILITARY_TIME_FORMAT = 'MM/DD/YYYY LT';
export const ESTIMATE_STATUS_FORMATS = {
    NOT_SENT: 'Added (Not Sent)',
    IN_PROGRESS: 'In Progress',
    COMMITTED: 'Committed',
    SENT: 'Sent',
    READY_FOR_REVIEW: 'Pending Review',
    APPROVED: 'Approved',
    AUTOMATICALLY_APPROVED: 'Approved',
    REJECTED: 'Rejected',
    MANUALLY_CLOSED: 'Manually Closed',
    RECOMMENDED_TOTAL_LOSS: 'Recommended Total Loss',
    SUPPLEMENTED: 'Supplemented',
    SUPPLEMENT_REQUESTED: 'Supplement Requested',
    REVISED: 'Revised',
    MSO_APPROVED: 'MSO Approved',
    PENDING_MSO_REVIEW: 'Pending MSO Review',
    CHANGE_REQUESTED: 'Change Requested'
};
//# sourceMappingURL=Constants.js.map